import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackAddToCart } from '../utils/pixel';
export function OfferCTA() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="oferta" className="relative py-24 px-6 z-10 bg-gradient-to-b from-night-900 via-night-800 to-night-900 border-t border-gold-500/20" data-id="element-152">
      <div ref={ref} className={`max-w-4xl mx-auto text-center section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-153">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-cream-100 mb-6 leading-tight" data-id="element-154">
          Recupera tus noches y tu energía por menos de lo que cuesta una cena.
        </h2>

        <p className="text-xl text-cream-200 mb-12" data-id="element-155">
          Obtén el sistema completo "Ritual de Paz Nocturna" hoy mismo.
        </p>

        <div className="glass-card max-w-lg mx-auto p-10 rounded-3xl border-gold-500/30 mb-10 relative overflow-hidden" data-id="element-156">
          {/* Subtle glow effect behind price */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-157" />

          <div className="relative z-10" data-id="element-158">
            <span className="inline-block px-4 py-1 rounded-full bg-gold-500/20 text-gold-400 text-sm font-bold uppercase tracking-widest mb-4" data-id="element-159">
              Precio Especial
            </span>
            <div className="text-3xl md:text-4xl text-cream-200/50 line-through font-heading mb-2" data-id="element-160">
              $18.00
            </div>
            <div className="text-7xl md:text-8xl font-heading font-bold text-cream-100 mb-3" data-id="element-161">
              $6.39
            </div>
            <span className="inline-block px-5 py-2 rounded-full bg-green-500/20 text-green-400 text-lg font-bold mb-8" data-id="element-162">
              ¡Ahorra 64%!
            </span>

            <a href="https://guiasparavivir.com/cart/52479158714657:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full bg-gold-500 hover:bg-gold-400 text-night-900 font-bold text-lg md:text-xl py-5 px-8 rounded-full transition-all duration-300 transform hover:scale-105 animate-glow-pulse shadow-xl text-center no-underline" aria-label="Comprar Ritual de Paz Nocturna" data-id="element-163">
              ¡SÍ, QUIERO DORMIR EN PAZ!
              <span className="block text-sm font-medium opacity-80 mt-1" data-id="element-164">
                DESCARGAR AHORA
              </span>
            </a>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 text-cream-200/80 text-sm md:text-base mb-8" data-id="element-165">
          <ShieldIcon className="w-5 h-5 text-gold-400" data-id="element-166" />
          <span data-id="element-167">Acceso inmediato en PDF. Pago seguro y privado.</span>
        </div>

        {/* 30-day Guarantee */}
        <div className="max-w-lg mx-auto glass-card rounded-2xl p-6 md:p-8 border-gold-500/20 text-center" data-id="element-168">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-169">
            <ShieldIcon className="w-6 h-6 text-gold-400" data-id="element-170" />
            <span className="text-lg font-heading font-bold text-gold-400" data-id="element-171">
              Garantía de 30 días
            </span>
          </div>
          <p className="text-cream-200/90 leading-relaxed italic" data-id="element-172">
            "Si no logras mejorar tu descanso en 30 días aplicando el Ritual de
            Paz Nocturna, te devolvemos tu dinero sin preguntas."
          </p>
        </div>
      </div>
    </section>;
}